"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { Authenticator, ThemeProvider } from "@aws-amplify/ui-react";
import { api } from "@/lib/api-client";
import { isCognitoConfigured } from "@/lib/amplify-config";
import { thexisTheme } from "@/lib/amplify-theme";
import { authServices } from "@/lib/amplify-auth-services";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { AuthCard } from "@/components/auth/AuthCard";

const DEV_ROLES = [
  {
    label: "Enter as Analyst",
    token:
      "Test 10000000-0000-0000-0000-000000000001:analyst:00000000-0000-0000-0000-000000000001",
  },
  {
    label: "Enter as Counsel",
    token:
      "Test 10000000-0000-0000-0000-000000000002:counsel:00000000-0000-0000-0000-000000000001",
  },
];

const SIGN_IN_COPY = {
  eyebrow: "Sign in",
  heading: "Welcome back.",
  lede: "Continue your claim intelligence workspace.",
} as const;

function DevLoginPage() {
  const router = useRouter();

  function handleLogin(token: string) {
    api.setToken(token);
    router.push("/dashboard");
    router.refresh();
  }

  return (
    <AuthCard {...SIGN_IN_COPY}>
      <div className="flex flex-col gap-3">
        {DEV_ROLES.map((role) => (
          <Button
            key={role.label}
            variant="accent"
            size="lg"
            className="w-full"
            onClick={() => handleLogin(role.token)}
          >
            {role.label}
          </Button>
        ))}
        <p className="mt-2 text-center text-[12px] text-muted-foreground">
          Dev mode — Cognito not configured
        </p>
      </div>
    </AuthCard>
  );
}

function CognitoLoginPage() {
  return (
    <AuthCard {...SIGN_IN_COPY}>
      <ThemeProvider theme={thexisTheme}>
        <Authenticator hideSignUp services={authServices}>
          {() => <></>}
        </Authenticator>
      </ThemeProvider>
    </AuthCard>
  );
}

export default function LoginPage() {
  const { user } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (user) router.replace("/dashboard");
  }, [user, router]);

  if (isCognitoConfigured) return <CognitoLoginPage />;
  return <DevLoginPage />;
}
